export const prodVariables = {
    ionicEnvName: 'prod',

    loopbackApiVersion: 'api',

    //url del MD de la documentacion
    faqUrl: 'http://documentacionvaltalia.alialabs.com/mdwiki.html#!index.md',

    // id de la playstore
    appPlayStoreId: 'com.alialabs.valtalia',

    // Enviar logs a sentry
    sentryEnabled: true,

    // url de loopback
    loopbackBaseUrl: 'https://devapi.valtalia.alialabs.com',

    hosts: [
        {order: 0, id: 'sidro', name: 'Sidro Des'},
        {order: 1, id: 'belgica_test', name: 'Bélgica Test'},
        {order: 2, id: 'sogapol_test', name: 'Sogapol Test'},
    ]
};



// WEBPACK FOOTER //
// ./envioronment-variables/production.ts